mutation inviteUsers($input: InviteUserInput!) {
  result: inviteUsers(input: $input) {
    invited {
      email
      success
      reason
      role
    }
  }
}
